import ApiBase from './api-base'
import { ACTIVE_BASE_REST } from './constants'

export default class Operation extends ApiBase {
  constructor(store) {
    const path = `${ACTIVE_BASE_REST}/operation`

    super(store, path)
  }

  serviceList(filter, showProgress) {
    return this._request({
      action: 'service/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  operationList(filter, showProgress) {
    return this._request({
      action: 'operation/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
